import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { InlineSVGModule } from 'ng-inline-svg';
import { RenewalsQuoteAcceptDialogComponent } from './components/renewals-quote-accept-dialog/renewals-quote-accept-dialog.component';
import { RenewalsQuoteRejectReasonDialogComponent } from './components/renewals-quote-reject-reason-dialog/renewals-quote-reject-reason-dialog.component';
import { RenewalsRejectReasonDialogComponent } from './components/renewals-reject-reason-dialog/renewals-reject-reason-dialog.component';
import { RenewalsMatrixContractDetailsComponent } from './pages/renewals-matrix-contract-details/renewals-matrix-contract-details.component';
import { RenewalsMatrixCustomerDetailsComponent } from './pages/renewals-matrix-customer-details/renewals-matrix-customer-details.component';
import { RenewalsMatrixGetQuoteComponent } from './pages/renewals-matrix-get-quote/renewals-matrix-get-quote.component';
import { RenewalsMatrixUtilityAccountsComponent } from './pages/renewals-matrix-utility-accounts/renewals-matrix-utility-accounts.component';
import { RenewalsMatrixYoureDoneComponent } from './pages/renewals-matrix-youre-done/renewals-matrix-youre-done.component';
import { MaterialModule } from '@app/app.material.module';
import { SharedModule } from '@app/shared/shared.module';
import { FileManagementModule } from '@app/filemanagement/file-management.module';
import { WizardBarModule } from '@app/wizard-bar/wizard-bar.module';
import { QuotingModule } from '@quoting/quoting.module';
import { RenewalsMatrixService } from './services/renewals-matrix.service';
import { WizardStepCol, WizardValidationService } from '@app/wizard-bar/services/wizard.service';
import { RenewalsMatrixConstants } from './models/renewals-matrix-constants';
import { RenewalsMatrixRoutingModule } from './renewals-matrix-routing.module';

@NgModule({
  declarations: [
    RenewalsMatrixCustomerDetailsComponent,
    RenewalsMatrixUtilityAccountsComponent,
    RenewalsMatrixGetQuoteComponent,
    RenewalsMatrixYoureDoneComponent,
    RenewalsQuoteAcceptDialogComponent,
    RenewalsQuoteRejectReasonDialogComponent,
    RenewalsRejectReasonDialogComponent,
    RenewalsMatrixContractDetailsComponent,
  ],
  exports: [
    RenewalsMatrixCustomerDetailsComponent,
    RenewalsMatrixUtilityAccountsComponent,
    RenewalsMatrixGetQuoteComponent,
    RenewalsMatrixYoureDoneComponent,
  ],
  imports: [
    CommonModule,
    InlineSVGModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatTableModule,
    MaterialModule,
    MatCheckboxModule,
    MatDialogModule,
    MatSelectModule,
    MatIconModule,
    FileManagementModule,
    WizardBarModule,
    QuotingModule,
    SharedModule,
    RenewalsMatrixRoutingModule
  ],
  providers: [RenewalsMatrixService,
    { provide: WizardStepCol, useValue: { steps: RenewalsMatrixConstants.wizardSteps } as WizardStepCol },
    { provide: WizardValidationService, useClass: RenewalsMatrixService },
  ]
})
export class RenewalsMatrixModule { }
